/**
 * Created by JAVIER on 10/31/2019.
 */
import React from 'react';
import * as constants from './constants';
import { Modal, Row, Col, Input, Progress, Form } from 'antd';
class GenericModal extends React.Component {

    handleOnChange = (e) =>{
        this.folderName =  e.target.value
    }

    renderContent = (props) => {

        const data = props.data;

        if ( props.action === constants.UPLOAD_FILES) {
            this.title = 'File upload';
            return Object.keys(data).map((key, idx) => {
                return (
                    <Row key={idx}>
                        <Col span={16}>{data[key].name}</Col>
                        <Col span={8}><Progress percent={data[key].percent} size="small"
                                                status={data[key].status}/></Col>
                    </Row>
                )
            });
        }

        if (props.action === constants.ADD_FOLDER){
            this.title = 'Add new folder';
            return (
                <Form id="add-rename-form">
                    <label> Enter folder name: </label>
                    <Input autoFocus onChange={this.handleOnChange}/>
                </Form>
            )
        }

        if (props.action === constants.RENAME_FOLDER){
            this.title = 'Rename folder';
            return (
                <Form id="add-rename-form">
                    <label>Enter folder name: </label>
                    <Input autoFocus defaultValue={data} onChange={this.handleOnChange}/>
                </Form>
            )
        }
    };

    render() {

        const content = this.renderContent(this.props);
        return (
            <div>
                <Modal
                    title={this.title}
                    visible={this.props.visible}
                    onOk={ ()=> {this.props.onOk(this.folderName)}}
                    onCancel={() =>{ this.props.onCancel()}}
                    okButtonProps={{ form: 'add-rename-form', key: 'submit', htmlType: 'submit' }}
                >
                    {content}
                </Modal>
            </div>
        )
    }

}

export default GenericModal;